import {
    CHECK_HIDE_CUST_NUM,
    HIDE_CUST_NUM,
    SHOW_INVOICE_AMOUNT_FIELD,
    STORE_CUSTOMER_FIELDS
  } from "../actions/callCompletedAction";
  
  const initialState = {
    checkHideCustNum: false,
    hideCustomerNumber: false,
    showInvoiceAmountField: false,
    customerFields: []
  };
  
  const styleNameReducer = (state = initialState, action) => {
    switch (action.type) {
      case CHECK_HIDE_CUST_NUM:
        return {
          ...state,
          checkHideCustNum: true
        };

        case HIDE_CUST_NUM:
            return {
                ... state,
                hideCustomerNumber : action.payload
            }

            case SHOW_INVOICE_AMOUNT_FIELD:
              return {
                ...state,
                showInvoiceAmountField: action.payload,
              };
          case STORE_CUSTOMER_FIELDS: 
              return {
                ...state,
                customerFields: action.payload
              }
      default:
        return state;
    }
  };
  
  export default styleNameReducer;
  